<template>
  <div class="px-10 py-10 max-w-4xl mx-auto">
    <h1 class="text-2xl font-bold mb-6">Add a Job</h1>
    <form @submit.prevent="addJob" class="space-y-6">
      <div class="form-group">
        <label for="jobTitle" class="block text-sm font-medium text-gray-700">Job Title</label>
        <input type="text" id="jobTitle"
               class="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-brand-500 focus:ring-brand-500"
               v-model="jobTitle" required />
      </div>

      <div class="form-group">
        <label for="company" class="block text-sm font-medium text-gray-700">Company</label>
        <input type="text" id="company"
               class="mt-1 block w-1/2 rounded-md shadow-sm focus:border-brand-500 focus:ring-brand-500"
               v-model="company" required />
      </div>

      <div class="form-group">
        <label for="description" class="block text-sm font-medium text-gray-700">Description</label>
        <textarea id="description"
                  class="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-brand-500 focus:ring-brand-500"
                  v-model="description" rows="8"></textarea>
      </div>

      <div class="form-group">
        <label for="jobUrl" class="block text-sm font-medium text-gray-700">Job URL</label>
        <input type="url" id="jobUrl"
               class="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-brand-500 focus:ring-brand-500"
               v-model="jobUrl" />
      </div>

      <div class="form-group">
        <label for="salaryRange" class="block text-sm font-medium text-gray-700">Salary Range</label>
        <input type="text" id="salaryRange"
               class="mt-1 block w-1/3 border-gray-300 rounded-md shadow-sm focus:border-brand-500 focus:ring-brand-500"
               v-model="salaryRange" />

      </div>

      <div class="form-group">
        <label for="date" class="block text-sm font-medium text-gray-700">Date applied</label>
        <input type="date" id="date"
               class="mt-1 block 1/2 border-b-2 border-gray-300 rounded-md shadow-sm focus:border-brand-500 focus:ring-brand-500"
               v-model="jobDate" />
      </div>

      <BaseButton type="submit" text="Add Job" />
    </form>
  </div>
</template>
<script lang="ts">
import api from '@/services/api';
import BaseButton from '@/components/BaseButton.vue';
import { toLocalDateInputValue } from '@/utils/date';

export default {
  components: {
    BaseButton,
  },
  data() {
    return {
      jobTitle: '' as string,
      company: '' as string,
      description: '' as string,
      jobUrl: '' as string,
      salaryRange: '' as string,
      jobDate: '' as string,
    };
  },
  methods: {
    async addJob(): Promise<void> {
      const jobData = {
        job_title: this.jobTitle,
        company: this.company,
        description: this.description,
        job_url: this.jobUrl,
        salary_range: this.salaryRange,
        job_date: this.jobDate ? this.jobDate : this.getFormattedDate(),
      };
      console.log('Adding job:', jobData);
      try {
        await api.addJob(jobData);
        this.$router.push('/');
      } catch (error) {
        console.error('Error adding job:', error);
      }
    },

    getFormattedDate(): string {
      return toLocalDateInputValue();
    }
  }
};
</script>

<style scoped>
/* .form-group {
  margin-bottom: 1rem;
  width: 80%;
}

label {
  display: block;
  margin-bottom: 0.5rem;
}

input[type="text"],
input[type="url"],
textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  background-color: #4CAF50;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #45a049;
} */
</style>
